module.exports = __webpack_public_path__ + "img/switch-event.089dae59.svg";